import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { backgroundColorLevelCurrent, breakWidth1600 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const Outer = styled.div.withConfig({
  componentId: "sc-zn25zs-0"
})(["padding:0;max-width:100%;"]);
const Inner = styled.div.withConfig({
  componentId: "sc-zn25zs-1"
})(["background:", ";margin:0 auto;max-width:", ";"], backgroundColorLevelCurrent, breakWidth1600);
const PageWrapper = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Outer, {
    children: /*#__PURE__*/_jsx(Inner, {
      children: children
    })
  });
};
PageWrapper.propTypes = {
  /** Page content */
  children: PropTypes.node.isRequired
};
export default PageWrapper;